// src/routes/AppRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/Auth/ProtectedRoute';
import AdminLayout from '../components/layout/AdminLayout';
import UsersPage from '../pages/UsersPage';
import SettingsPage from '../pages/SettingsPage';
import NotFoundPage from '../pages/NotFoundPage';
import LoginPage from '../pages/LoginPage';
import ConfigurationsPage from '../pages/ConfigurationPage';
import OrdersPage from '../pages/OrdersPage';
import ESimPackagesPage from '../pages/ESimPackagesPage';
import CountriesPage from '../pages/CountriesPage';
import RegionsPage from '../pages/RegionsPage';
import EsimPackagesListRegion from '../pages/RegionalPackagesPage';
import LifetimePackages from '../pages/PrepaidPackagesPage';
import UnlimitedPackagesPage from '../pages/UnlimitedPackagesPage';
import VoicePackagesPage from '../pages/VoicePackagesPage';
import ContinentsPage from '../pages/ContinentsPage';
import ContentManagementPage from '../pages/ContentManagementPage';
import CatalogPage from '../pages/CatalogPage';
import AppVersionsPage from '../pages/AppVersionsPage';
import AppConfigPage from '../pages/AppConfigPage';
import StatsPage from '../pages/StatsPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<LoginPage />} /> {/* DÜZELTİLDİ */}

      {/* Private Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          {/* AdminLayout içindeki Outlet'e render edilecek sayfalar */}
          {/* Ana sayfa İstatistikler. Sayfayı '/' altında ikinci kez çizmek yerine
              /stats'e yönlendiriyoruz: tek kanonik adres kalsın ve sol menüdeki
              madde işaretli görünsün. LoginPage `location.state.from` yoksa '/'
              adresine gittiği için girişten gelen kullanıcı da buraya düşer. */}
          <Route path='/' index element={<Navigate to="/stats" replace />} />
          <Route path="/orders" element={<OrdersPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/stats" element={<StatsPage />} /> {/* Admin istatistikleri */}
          <Route path="/users" element={<UsersPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/regions-package" element={<EsimPackagesListRegion />} /> {/* DÜZELTİLDİ */}
          <Route path="/lifetime-packages" element={<LifetimePackages />} /> {/* DÜZELTİLDİ */}
          <Route path="/packages" element={<ESimPackagesPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/unlimited-packages" element={<UnlimitedPackagesPage />} /> {/* Sınırsız paketler (v2 şeması) */}
          <Route path="/voice-packages" element={<VoicePackagesPage />} /> {/* Ses paketleri (v2 şeması) */}
          <Route path="/catalog" element={<CatalogPage />} /> {/* Katalog v2: bundle + plan */}
          <Route path="/continents" element={<ContinentsPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/countries" element={<CountriesPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/regions" element={<RegionsPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/configurations" element={<ConfigurationsPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/content-management" element={<ContentManagementPage />} /> {/* DÜZELTİLDİ */}
          <Route path="/settings" element={<SettingsPage />} /> {/* DÜZELTİLDİ */}
          {/* Uygulama Ayarları artık Ayarlar sayfasının bir sekmesi; eski adres
              kayıtlı olanlar için yönlendiriliyor. */}
          <Route path="/app-settings" element={<Navigate to="/settings" replace />} />
          <Route path="/app-versions" element={<AppVersionsPage />} /> {/* Force update eşikleri */}
          <Route path="/app-config" element={<AppConfigPage />} /> {/* Uzaktan konfigürasyon */}
        </Route>
      </Route>

      {/* Eşleşmeyen Rotalar */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;